<template>
  <div class="event-list">

    <h2>{{ $t('title.events') }}</h2>

    <div class="filters">
      <el-collapse v-model="collapse" >

        <el-collapse-item :title="$t('title.custom-filters')" name="1">

            <el-row :gutter="10">

              <el-col :xs="24" :md="12">
                <event-list-config @filtersChanged="filtersChanged" hide-event-type-id />
              </el-col>

            </el-row>

        </el-collapse-item>

      </el-collapse>
    </div>

    <el-row>
      <el-col :span="24">
        <event-table
          :filters="mergedFilters"
          :showSearch="false"
          :profile="profile"
        />
      </el-col>
    </el-row>

  </div>
</template>

<script>
import EventListConfig from 'components/event/EventTableConfig'
import EventTable from 'components/event/EventTable'
import profiles from 'components/event/profiles'

export default {
  name: 'event-list',
  data () {
    return {
      collapse: null,
      filters: {}
    }
  },
  computed: {
    mergedFilters () {
      return { ...this.filters, ...profiles[this.profile] }
    },
    profile () {
      return this.$route.meta.profile
    }
  },
  methods: {
    filtersChanged (filters) {
      this.filters = filters
    }
  },
  components: {
    EventListConfig,
    EventTable
  }
}
</script>

<style lang="scss">
.event-list {
  .filters {
    margin-bottom: 10px;

    .el-collapse-item__header {
      padding-left: 10px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// EventList.vue?5ced1518